import axios from '../../../http';

function initialState() {
  return {
    titleId: null,
    firstName: null,
    lastName: null,
    dateOfBirth: null,
    emailAddress: null,
    dayTimePhone: null,
    employmentStatusId: null
  };
}

const state = initialState();

const getters = {};

const actions = {
  async update ({ state, rootState, dispatch }) {
    const { switchKey } = rootState.storage;

    try {
      const { status } = await axios({
        method: 'POST',
        url: '/request/switch/pro/update/personal',
        data: { switchKey, ...state }
      });

      if (status != 200) {
        throw 'customer';
      }
    } catch (error) {
      throw 'customer';
    }
  }
};

const mutations = {
  updateState (state, value) {
    state = Object.assign(state, value);
  },
  resetState (state) {
    state = Object.assign(state, initialState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
